import { connect } from 'react-redux'

import { createLead } from '../../../../actions/leadActionCreators'

const mapStateToProps = ({ busy, lead, appConfig }, ownProps) => {
  const customerRecruitmentQuestions = appConfig.customerRecruitmentQuestions || []

  // create key/value defaults for customer questions so that skipped questions
  // default to null instead of not being included in submitted values
  const customQuestionDefaults = {}
  for (let i = 0; i < customerRecruitmentQuestions.length; i++) {
    customQuestionDefaults[`custom-question-${i}`] = null
  }

  return {
    enableRunningFor: appConfig.enableRunningFor,
    customerRecruitmentQuestions: customerRecruitmentQuestions,
    busy: busy,
    initialValues: {
      ...lead, // for email and address
      ...ownProps,
      ...customQuestionDefaults
    },
  }
}

const formatArrayAnswers = (values) => {
  const valsCopy = Object.assign({}, values)

  Object.keys(valsCopy).forEach((key) => {
    if (Array.isArray(valsCopy[key])) {
      valsCopy[key] = valsCopy[key].filter(x => x).join(' & ')
    }
  })

  return valsCopy
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (values) => dispatch(createLead(formatArrayAnswers(values))),
})

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/components/Position/RunModal/LeadForm/leadFormContainer.js